// extracted by mini-css-extract-plugin
export default {"container":"loading-planos_container__jaY51","loading":"loading-planos_loading__9HKlK"};